export const el = {
    'nav.today': "Επισκόπηση Σήμερα",
    'nav.calendar': "Ημερολόγιο Ζήτησης",
    'nav.rates': "Τιμές & Κανόνες",
    'nav.automation': "Αυτοματοποίηση",
    'nav.audit': "Αρχείο Ελέγχου",
    'nav.settings': "Ρυθμίσεις",
    'sidebar.status': "Συνδεδεμένο",
    'stat.occupancy': "Πληρότητα",
    'stat.adr': "Μέση Τιμή (ADR)",
    'stat.revpar': "RevPAR",
    'stat.revenue': "Εκτ. Έσοδα",
    'stat.trend.vsLastWeek': "vs Περ. Εβδ.",
    'stat.trend.onPace': "Εντός στόχου",
    'dashboard.actions.title': "Προτεινόμενες Ενέργειες",
    'dashboard.actions.empty': "Δεν βρέθηκαν ενέργειες.",
    'filter.all': "Όλα",
    'filter.pricing': "Τιμολόγηση",
    'filter.restriction': "Περιορισμοί",
    'action.approve': "Έγκριση",
    'action.reject': "Απόρριψη",
    'action.risk.low': "χαμηλό ρίσκο",
    'action.risk.medium': "μέτριο ρίσκο",
    'action.risk.high': "υψηλό ρίσκο",
    'action.label.current': "Τρέχον",
    'action.label.proposed': "Πρόταση",
    'action.metric.impact': "Αντίκτυπος",
    'action.metric.why': "Αιτία",
    'action.status.executed': "Αυτόμ. Εκτέλεση",
    'header.search': "Αναζήτηση...",
    'header.logout': "Αποσύνδεση",
    'auto.level.title': "Επίπεδο Αυτόματου Πιλότου",
    'auto.level.manual': "Χειροκίνητο",
    'auto.level.manual.desc': "Εγκρίνετε κάθε πρόταση ξεχωριστά.",
    'auto.level.assisted': "Υποβοηθούμενο",
    'auto.level.assisted.desc': "Αυτόματη έγκριση χαμηλού ρίσκου. Έλεγχος μεγάλων αλλαγών.",
    'auto.level.auto': "Πλήρως Αυτόματο",
    'auto.level.auto.desc': "Η AI διαχειρίζεται τις τιμές 24/7 εντός ορίων.",
    'auto.level.active': "Ενεργό",
    'auto.guardrails.title': "Όρια Ασφαλείας",
    'auto.guardrails.maxIncrease': "Μέγ. Ημερήσια Αύξηση",
    'auto.guardrails.maxIncrease.desc': "Αποφυγή απότομων αυξήσεων.",
    'auto.guardrails.maxDecrease': "Μέγ. Ημερήσια Μείωση",
    'auto.guardrails.maxDecrease.desc': "Αποφυγή υπερβολικών μειώσεων.",
    'auto.guardrails.minRate': "Ελάχιστη Τιμή",
    'auto.guardrails.minRate.desc': "Ποτέ κάτω από αυτή την τιμή.",
    'auto.emergency.title': "Έλεγχος Έκτακτης Ανάγκης",
    'auto.emergency.label': "Διακοπή Έκτακτης Ανάγκης",
    'auto.emergency.desc': "Άμεση παύση όλης της αυτοματοποίησης.",
    'auto.emergency.btn': "ΠΑΥΣΗ ΣΥΣΤΗΜΑΤΟΣ",
    'rates.filter.all': "Όλοι οι Τύποι Δωματίων",
    'rates.filter.next14': "Επόμενες 14 Ημέρες",
    'rates.export': "Εξαγωγή",
    'audit.table.time': "Ώρα",
    'audit.table.actor': "Χρήστης",
    'audit.table.category': "Κατηγορία",
    'audit.table.action': "Ενέργεια",
    'audit.table.details': "Λεπτομέρειες",
    'audit.table.status': "Κατάσταση",
    'settings.pms.title': "Σύνδεση PMS",
    'settings.pms.connected': "Συνδέθηκε με",
    'settings.pms.disconnect': "Αποσύνδεση",
    'settings.account.title': "Λογαριασμός",
    'settings.account.role': "Ρόλος",
    'settings.restart': "Επανεκκίνηση Onboarding",
    'onboard.title': "Σύνδεση PMS",
    'onboard.desc': "Επιλέξτε το PMS σας για συγχρονισμό.",
    'onboard.connecting': "Σύνδεση...",
    'onboard.connect': "Σύνδεση",
    'onboard.success.title': "Ρύθμιση Ολοκληρώθηκε!",
    'onboard.success.desc': "Το ξενοδοχείο **SynthHotel Berlin** συγχρονίστηκε.",
    'onboard.success.sub': "Εισήχθησαν 3 τύποι δωματίων, 14 πλάνα τιμών και 243 κρατήσεις.",
    'onboard.btn.dashboard': "Μετάβαση στο Dashboard",
    'action.dynamic.weekend.title': "Αύξηση Τιμής για Σ/Κ",
    'action.dynamic.weekend.desc': "Πληρότητα > 75% Σάββατο, ισχυρή ζήτηση (+12 δωμ. σε 24ω).",
    'action.dynamic.minstay.title': "Ενερ. Ελάχ. Διαμονής 2 Νύχτες",
    'action.dynamic.minstay.desc': "Συναυλία Taylor Swift. Αποφυγή διαμονών 1 νύχτας.",
    'action.dynamic.distress.title': "Μείωση Τιμής (Χαμηλή Ζήτηση)",
    'action.dynamic.distress.desc': "Πληρότητα 35% Τρίτη. Ανταγωνιστές μείωσαν κατά €10.",
    'action.dynamic.gap.title': "Κάλυψη Κενού: Αφαίρεση CTA",
    'action.dynamic.gap.desc': "Κενό μιας νύχτας. Αφαίρεση 'Κλειστό στην Άφιξη' για πώληση.",
};
